import { render, staticRenderFns } from "./CourseRecordItem.vue?vue&type=template&id=3d681333&"
import script from "./CourseRecordItem.vue?vue&type=script&lang=js&"
export * from "./CourseRecordItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports